import config from 'config'
import { Vue, Component } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { CookieCategory, CookieCategoryStatus } from '../store/cookies/types'

import CookieConsentCategoryBlock from '@/components/CookieConsentCategoryBlock.vue'

@Component({
  components: {
    CookieConsentCategoryBlock
  }
})
export default class CookieConsentMixin extends Vue {
  @Action('COOKIES/loadCookies') loadCookies!: () => void
  @State(state => state.COOKIES.categories) categories!: CookieCategory[]
  @Action('COOKIES/update') update!: (postMessageId?: string) => void
  @Action('COOKIES/changeValues') changeValues!: (cookieCategoryStatus: CookieCategoryStatus[]) => void

  get privacyUrl () {
    return config.cookies.privacyUrl
  }

  async mounted () {
    await this.loadCookies()
  }

  accept () {
    this.update('cookie-consent')
  }
}
